import API from '@/api';

const GET_COUNTRIES = 'GET_COUNTRIES';
const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
const GET_COUNTRIES_FAILED = 'GET_COUNTRIES_FAILED';

// Enabled the module to be namespaced
const namespaced = true;

// Country initial state
const state = {
  all: [],
  loadingCountries: false,
};

// Country mutations
const mutations = {
  [GET_COUNTRIES](state) {
    state.loadingCountries = true;
  },

  [GET_COUNTRIES_SUCCESS](state, countries) {
    state.all = countries;
    state.loadingCountries = false;
  },

  [GET_COUNTRIES_FAILED](state) {
    state.loadingCountries = false;
  },
};

// Country actions
const actions = {
  // ** all fetches the countries list from the API
  async all({ commit, getters, rootState }) {
    let response;

    commit(GET_COUNTRIES);

    const { countryList = [] } = getters;
    const {
      countries: { all = [] },
    } = rootState;

    const countryArr = all?.length ? all : countryList?.length ? countryList : [];

    //* Custom cache setup for /countries
    //* If we have the country list in state, return that instead of calling api again
    if (countryArr?.length) {
      commit(GET_COUNTRIES_SUCCESS, countryArr);
      return Promise.resolve(countryArr);
    }

    try {
      response = await API.countries.list();
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_COUNTRIES_FAILED);
        reject(response);
      } else {
        commit(GET_COUNTRIES_SUCCESS, response.data);
        // Return GET data  within promise
        resolve(response.data);
      }
    });
  },

  // ** listV3  fetches the countries list from the API
  async listV3({ commit, getters, rootState }) {
    let response;

    commit(GET_COUNTRIES);

    const { countryList = [] } = getters;
    const {
      countries: { all = [] },
    } = rootState;

    const countryArr = all?.length ? all : countryList?.length ? countryList : [];

    //* Custom cache setup for /countries
    //* If we have the country list in state, return that instead of calling api again
    if (countryArr?.length) {
      commit(GET_COUNTRIES_SUCCESS, countryArr);
      return Promise.resolve(countryArr);
    }

    try {
      response = await API.countries.listV3();
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_COUNTRIES_FAILED);
        reject(response);
      } else {
        commit(GET_COUNTRIES_SUCCESS, response.data);
        // Return GET data  within promise
        resolve(response.data);
      }
    });
  },
};

// Country getters
const getters = {
  // countryList returns a list of countries
  countryList: (state) => {
    return state.all;
  },
};

export default {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
